import React from "react";
import { compose } from "lodash/fp";
import { arrayOf, number, oneOfType, string } from "prop-types";

import { agentMatchItemPropType } from "../../propTypes";
import ConnectWithAgentCTABase from "./components/ConnectWithAgentCTA";
import ExpertsMatchDrawerBase from "./components/ExpertMatchDrawer";
import store from "./redux/store";
import withReduxProvider from "./redux/utilities/withReduxProvider";

const enhance = compose(withReduxProvider(store));

const ConnectWithAgentCTA = withReduxProvider(store)(ConnectWithAgentCTABase);
const ExpertsMatchDrawer = enhance(ExpertsMatchDrawerBase);

const ListingAgentMatchBanner = ({
  listingAgentMatches,
  propertyId,
  userId
}) => (
  <>
    <ConnectWithAgentCTA
      agentMatchItem={listingAgentMatches[0]}
      propertyId={propertyId}
    />
    <ExpertsMatchDrawer
      agentMatchItem={listingAgentMatches[0]}
      propertyId={propertyId}
      rootElementId="#site-wrapper"
      userId={userId}
    />
  </>
);

ListingAgentMatchBanner.propTypes = {
  listingAgentMatches: arrayOf(agentMatchItemPropType).isRequired,
  propertyId: number.isRequired,
  userId: oneOfType([number, string]).isRequired
};

export default ListingAgentMatchBanner;
